export const UNSAVED_CHANGES_PROMPT = 'You have unsaved changes. Are you sure you want to leave?';
